import Script from "next/script";
import { FC, Fragment } from "react";

const GTMScript: FC = () => {
  const isInternationalScriptsDisabled =
    process.env.NEXT_PUBLIC_IS_INTERNATIONAL_SCRIPTS_ACTIVE === "false";

  if (isInternationalScriptsDisabled) return null;

  return (
    <Fragment>
      <Script
        id="product-gtm-script"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-59JTVMCV');
  `,
        }}
      />
      <Script
        id="gtag-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          `,
        }}
      />
    </Fragment>
  );
};

export default GTMScript;
